<template>
    <button
        type="button"
        class="sub-item"
        :class="{ 'is-active': active }"
        :role="role || null"
        @mousedown="$emit('click', $event)"
    >
        <svg
            v-if="icon"
            class="sub-item-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
        >
            <path :d="icon" />
        </svg>
        <span class="sub-item-label">{{ label }}</span>
    </button>
</template>

<script>
export default {
    name: "SidebarNavSubItem",
    props: {
        label: { type: String, required: true },
        // SVG path data feather-style (stroke 2px, viewBox 24x24).
        icon: { type: String, default: "" },
        active: { type: Boolean, default: false },
        // ARIA role opcional. Pasar "menuitem" cuando se usa dentro de un
        // menú (flyout). En el acordeón inline, va vacío.
        role: { type: String, default: "" },
    },
};
</script>

<style lang="scss" scoped>
.sub-item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background-color: transparent;
    border: none;
    border-radius: var(--sidebar-radius, 6px);
    color: var(--sidebar-ink-muted, #667085);
    font-family: inherit;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    cursor: pointer;
    user-select: none;
    transition: background-color var(--app-transition-fast),
        color var(--app-transition-fast);

    &:hover {
        background-color: var(--sidebar-hover, rgba(16, 24, 40, 0.03));
        color: var(--sidebar-ink, #1d2939);
    }

    &:focus-visible {
        outline: 2px solid var(--sidebar-accent, #0d5154);
        outline-offset: -2px;
    }

    &.is-active {
        background-color: var(--sidebar-accent-wash, rgba(13, 81, 84, 0.06));
        color: var(--sidebar-accent, #0d5154);
        font-weight: 600;
    }
}

.sub-item-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    color: var(--sidebar-ink-faint, #98a2b3);
}

.sub-item.is-active .sub-item-icon {
    color: var(--sidebar-accent, #0d5154);
}

.sub-item-label {
    flex: 1;
}
</style>
